﻿import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AlertService, AuthenticationService } from '../../_services';
import { RestService } from 'src/app/_services/rest.service';

@Component({ templateUrl: 'login.component.html' })
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    gmail = false;
    facebook = false;
    registrar = false;


    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private restService: RestService,
        private alertService: AlertService
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.restService.getParam('login.facebook').subscribe(data => {
            this.facebook = data.valor.toUpperCase() === 'TRUE';
        });
        this.restService.getParam('login.gmail').subscribe(data => {
            this.gmail = data.valor.toUpperCase() === 'TRUE';
        });
        this.restService.getParam('login.registrar').subscribe(data => {
            this.registrar = data.valor.toUpperCase() === 'TRUE';
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .subscribe(
                data => {                    
                    if (data) {
                        this.router.navigate(['/user/lista']);
                    } else {
                        this.alertService.error('<h4>Acceso denegado</h4>Email o contrase&ntilde;a incorrecto.');
                        this.submitted = false;
                        this.loading = false;
                    }
                })
            ;
    }

    registerSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;

        const nuevo: any = {
            email : this.f.username.value,
            firstName: '',
            lastName: '',
            password: this.f.password.value
        }
        this.restService.post('/rest-api/register', nuevo)
            .subscribe(
                data => {
                    if (data.status === 200) {                        
                        this.authenticationService.setStorage(data.user);
                        this.router.navigate(['/user/lista']);
                    } else {                        
                        this.alertService.error('<h3>No se pudo</h3>El email ya est&aacute; en uso.', true);
                        this.submitted = false;
                        this.loading = false;
                    }
                });
    }
}
